
import tags from './tags/tags'

export default function(o, done){

  o.data.aaTags(o,function(aaTagsData){
    o.data.fullSequence(o,function(fullSequenceData){

      document.title = 'Open Memory Box'

      var slideshowDiv =
        o.component.slideshow(o,{markers:fullSequenceData.markers},function(){
          done(div)
        })

      var menuDiv = o.component.menu(o)

      var tagsDiv = tags(o, aaTagsData)

      var div = $('<div>')
      .css(o.mainDivCss)
      .addClass('iphoneNavbarFixTop')
      .addClass('iphoneNavbarFixBottom')  
      .append([

        slideshowDiv
        .css({
          position: 'fixed',
          objectFit: 'cover',
          overflow: 'hidden',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
        }),

        menuDiv
        .css({
          flex: '0 0 auto',
          width: '100%',
          zIndex: 1,
        }),

        $('<div>')
        .css({
          flex: '1 1 auto',
          pointerEvents: 'none',
        }),

        tagsDiv
        .css({
          flex: '0 0 auto',
          width: '100%',
          zIndex: 1,
        }),

      ])

      var observer =
        new MutationObserver(function(){
          if (document.body.contains(div[0])){
  
            observer.disconnect()
  
            if(o.store('antiArchiveTagsDivScrollPosition')){
              tagsDiv[0].scrollLeft = o.store('antiArchiveTagsDivScrollPosition')
            }

          }
        })
  
      observer.observe(document.body, {childList: true});
  
    })
  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchive/antiArchive.js